import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M16.6 2.998c-2.53-.659-5.098.043-7.09 1.558-2.15 1.634-3.607 4.199-3.607 6.97 0 3.254 1.975 5.48 4.602 6.77a.759.759 0 0 1 .143 1.26 13 13 0 0 1-2.223 1.453c2.522.647 5.079-.055 7.064-1.565 2.15-1.634 3.608-4.2 3.608-6.97 0-3.142-1.841-5.325-4.33-6.632a.761.761 0 0 1-.194-1.186A9.3 9.3 0 0 1 16.6 2.998m-7.964.354c2.471-1.88 5.784-2.72 9.027-1.595.477.165.789.614.814 1.11.024.495-.24.973-.694 1.19-.488.232-.98.56-1.456.968 2.397 1.54 4.235 3.998 4.235 7.449 0 3.315-1.735 6.301-4.198 8.174-2.472 1.879-5.784 2.72-9.027 1.595a1.23 1.23 0 0 1-.814-1.11c-.025-.495.24-.973.694-1.19.56-.267 1.094-.56 1.591-.883-2.463-1.535-4.371-4.015-4.371-7.534 0-3.315 1.735-6.301 4.199-8.174m3.879 6.764c-.956 0-1.772.827-1.772 1.9s.816 1.9 1.771 1.9c.956 0 1.772-.827 1.772-1.9s-.816-1.9-1.771-1.9m-3.238 1.9c0-1.854 1.427-3.4 3.238-3.4s3.237 1.546 3.237 3.4-1.427 3.4-3.238 3.4-3.237-1.546-3.237-3.4"
      clipRule="evenodd"
    />
  </>
);

const Weather1 = Icon('weather-1', svgContents);

export default Weather1;
